import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cross, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Verse-of-the-week card for the teacher Overview.
 * Renders nothing when the teacher has no Christian students or no learning verses.
 * Backend rotates the pick once per ISO week (deterministic).
 */
export default function VerseOfWeek() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/dashboard/verse-of-week");
        setData(res.data);
      } catch {
        setData({ verse: null });
      }
    })();
  }, []);

  if (!data || !data.verse) return null;
  const v = data.verse;

  return (
    <div
      className="relative overflow-hidden rounded-3xl border border-indigo-200 bg-gradient-to-br from-indigo-50 via-white to-white p-6 shadow-sm"
      data-testid="verse-of-week"
    >
      <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-indigo-100/50 blur-2xl pointer-events-none" />
      <div className="relative flex items-start gap-4">
        <div className="grid place-items-center w-11 h-11 rounded-2xl bg-indigo-500 text-white shrink-0">
          <Cross className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs uppercase tracking-[0.2em] font-semibold text-indigo-700">Verse of the week</span>
            <span className="text-[10px] uppercase tracking-[0.15em] text-stone-400" data-testid="verse-of-week-week">{data.week}</span>
          </div>
          <div className="mt-2 font-display text-2xl font-bold text-stone-900" data-testid="verse-of-week-ref">
            {v.reference}
          </div>
          {v.text && (
            <p className="mt-2 text-stone-700 leading-relaxed italic" data-testid="verse-of-week-text">
              &ldquo;{v.text}&rdquo;
            </p>
          )}
          <div className="mt-3 flex items-center justify-between gap-3 flex-wrap">
            <div className="text-xs text-stone-500">
              For <span className="font-semibold text-stone-800">{v.student_name}</span> — currently learning
            </div>
            <Link
              to={`/dashboard/students/${v.student_id}`}
              className="inline-flex items-center gap-1 text-sm font-semibold text-indigo-700 hover:text-indigo-900"
              data-testid="verse-of-week-go"
            >
              Open tracker <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
